
const basemaps = [
  {
    id: "osm",
    name: "OpenStreetMap",
    url: "https://tile.openstreetmap.org/{z}/{x}/{y}.png",
  },
  {
    id: "osm-hot",
    name: "OSM Humanitarian",
    url: "https://tile-a.openstreetmap.fr/hot/{z}/{x}/{y}.png",
  },
  {
    id: "carto-light",
    name: "Carto Light",
    url: "https://a.basemaps.cartocdn.com/light_all/{z}/{x}/{y}.png",
  },
  {
    id: "carto-dark",
    name: "Carto Dark",
    url: "https://a.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}.png",
  },
  {
    id: "carto-voyager",
    name: "Carto Voyager",
    url: "https://a.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}.png",
  },
  {
    id: "stamen-toner",
    name: "Toner",
    url: "https://tiles.stadiamaps.com/tiles/stamen_toner/{z}/{x}/{y}.png",
  },
  {
    id: "stamen-watercolor",
    name: "Watercolor",
    url: "https://tiles.stadiamaps.com/tiles/stamen_watercolor/{z}/{x}/{y}.jpg",
  },
  {
    id: "stamen-terrain",
    name: "Terrain",
    url: "https://tiles.stadiamaps.com/tiles/stamen_terrain/{z}/{x}/{y}.png",
  },
  {
    id: "esri-world",
    name: "ESRI World",
    url: "https://server.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}",
  },
  {
    id: "esri-satellite",
    name: "ESRI Satellite",
    url: "https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}",
  },
  {
    id: "esri-topo",
    name: "ESRI Topo",
    url: "https://server.arcgisonline.com/ArcGIS/rest/services/World_Topo_Map/MapServer/tile/{z}/{y}/{x}",
  },
  {
    id: "esri-gray",
    name: "ESRI Gray",
    url: "https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Base/MapServer/tile/{z}/{y}/{x}",
  },
  {
    id: "topo",
    name: "OpenTopoMap",
    url: "https://tile.opentopomap.org/{z}/{x}/{y}.png",
  },
  {
    id: "cycle",
    name: "CyclOSM",
    url: "https://a.tile-cyclosm.openstreetmap.fr/cyclosm/{z}/{x}/{y}.png",
  },
];

export default basemaps;